const combineFunctions = (...list) => {
  return (...args) => list.forEach((fn) => fn(...args));
};
export {
  combineFunctions as c
};
//# sourceMappingURL=combine-functions-6dfefdda.mjs.map
